import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'

import * as DmsService from '../supports/dms-service';
import { GlobalState, GlobalEvent } from './GlobalContext';
import MsgDialog from './MsgDialog';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { useForm, Controller } from "react-hook-form";
import dayjs from 'dayjs';


function ChangePwdDialog(props) {

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const { onClose, open, sysID } = props;
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const [showPwd, setShowPwd] = useState(false)


  const initData = () => {

    setValue('oldPwd', '');
    setValue('newPwd', '');
    setValue('newPwd2', '');


  }

  // Use when "open" changed
  useEffect(() => {
    // console.log("useEffect ChangePwdDialog[open]");

    if (open) {
      initData();
    }

  }, [open])

  // Setup inital form values
  const defaultFormValues = {
    oldPwd: "",
    newPwd: "",
    newPwd2: "",
  }

  // React Hook the form
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: defaultFormValues
  });


  const handleChangeShowPwd = (event) => {
    setShowPwd(event.target.checked);
  }

  const onSubmit = async (data) => {
    // console.log(data);

    if (data.oldPwd == data.newPwd) {
      setErrMsg('Old and new passwords should not be the same!');
      setShowError(true);
      return
    }

    if (data.newPwd != data.newPwd2) {
      setErrMsg('New and confirm new passwords should be the same!');
      setShowError(true);
      return
    }

    // Encode escape chars
    let vOldPassword = data.oldPwd.replace('%', '&#37;').replace('\\', '&#92;').replace('"', '&#34;').replace('=', '&#61;');
    let vNewPassword = data.newPwd.replace('%', '&#37;').replace('\\', '&#92;').replace('"', '&#34;').replace('=', '&#61;');


    setShowLoading(true);
    try {
      await DmsService.changePwdPromise(gState.sessionID, sysID, gState.userID, vOldPassword, vNewPassword);

      setShowLoading(false);

      setOpenSuccessDialog(true);

    } catch (e) {
      setShowLoading(false);

      onCatchPromiseError(e);

    }

  }

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const handleCloseSuccessToastClick = () => {
    setOpenSuccessDialog(false);

    handleCloseClick();
  }

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const submitBtnRef = useRef();

  const handleFormSubmit = () => {
    submitBtnRef?.current?.click();
  }

  return (
    <Dialog open={open}  >
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}

        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />

        <MsgDialog
          open={openSuccessDialog}
          title=""
          msgText="Password changed!"
          onClose={handleCloseSuccessToastClick}
        />

        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              // marginTop: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

            <FormGroup>
              <FormControlLabel control={<Switch checked={showPwd} onChange={handleChangeShowPwd} />} label="Show Password" />
            </FormGroup>

            <Box component="form" onSubmit={handleSubmit(onSubmit)} >

              <Controller
                name="oldPwd"
                control={control}
                render={({ field }) =>
                  <TextField
                    {...field}
                    margin="normal"
                    required
                    fullWidth
                    label="Old Password"
                    type={showPwd ? 'text' : 'password'}
                    InputLabelProps={{ shrink: true, }}
                  />
                }
              />

              <Controller
                name="newPwd"
                control={control}
                render={({ field }) =>
                  <TextField
                    {...field}
                    margin="normal"
                    required
                    fullWidth
                    label="New Password"
                    type={showPwd ? 'text' : 'password'}
                    InputLabelProps={{ shrink: true, }}
                  />
                }
              />

              <Controller
                name="newPwd2"
                control={control}
                render={({ field }) =>
                  <TextField
                    {...field}
                    margin="normal"
                    required
                    fullWidth
                    label="Confirm New Password"
                    type={showPwd ? 'text' : 'password'}
                    InputLabelProps={{ shrink: true, }}
                  />
                }
              />



              <Button type="submit" variant="contained" sx={{ display: "none" }} ref={submitBtnRef}  >Submit</Button>

            </Box>
          </Box>




        </Container>
      </DialogContent>



      <DialogActions>
        <Button onClick={handleCloseClick} >Cancel</Button>
        <Button variant="contained" onClick={handleFormSubmit} >Submit</Button>
      </DialogActions>

    </Dialog>
  );
}

ChangePwdDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  sysID: PropTypes.string,
};

export default ChangePwdDialog

